import {ENV} from '@/constants/EnvConstants';

export const isProduction = ENV.VITE_APP_ENV === 'production';
export const isTesting = ENV.VITE_APP_ENV === 'testing';
export const isDevelopment = ENV.VITE_APP_ENV === 'development';
export const isLocalhost = window?.location?.hostname === 'localhost';
